import { useState } from "react";

interface UploadImageProps {
  Image?: string;
  ButtonText?: string;
  bigImage? : boolean;
  onUpload?: (uploadedImg: File) => void; // Callback for uploaded image (accepting File object now)
}

export default function UploadImage({
  Image = "https://as1.ftcdn.net/v2/jpg/03/53/11/00/1000_F_353110097_nbpmfn9iHlxef4EDIhXB1tdTD0lcWhG9.jpg",
  ButtonText = "Upload an image",
  onUpload,
  bigImage = false
}: UploadImageProps) {
  const [previewImage, setPreviewImage] = useState(Image);

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      const allowedTypes = ["image/png", "image/jpeg", "image/jpg"];
      if (!allowedTypes.includes(file.type)) {
        alert("Only PNG, JPG, and JPEG files are allowed!");
        return;
      }

      const reader = new FileReader();
      reader.onload = () => {
        const result = reader.result as string;
        setPreviewImage(result); // Update the preview image
        if (onUpload) {
          onUpload(file); // Pass the file object to the parent component
        }
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <div className="flex space-x-4 items-center">
      {/* Preview Image */}
      {bigImage ? (
        <div className="bg-black/[.15] w-[80px] h-[80px] rounded">
          <img
            src={previewImage}
            alt="img"
            className="w-full h-full object-cover rounded border border-primary"
          />
        </div>
      ) : (
        <div className="bg-black/[.15] w-[80px] h-[80px] rounded-full">
          <img
            src={previewImage}
            alt="img"
            className="w-full h-full object-cover rounded-full border border-primary"
          />
        </div>
      )}

      {/* File Upload Button */}
      <div className="relative">
        <input
          type="file"
          accept=".png, .jpg, .jpeg"
          className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
          onChange={handleFileChange}
        />
        <div className="border border-primary bg-primary/[.15] rounded-full p-2 px-6 text-primary duration-300 hover:text-white hover:bg-primary_dark h-fit">
          <p>{ButtonText}</p>
        </div>
      </div>
    </div>
  );
}
